import React, {useEffect} from 'react';
import Lottie from 'lottie-web';
import { useMediaQuery } from 'react-responsive';
import JsonData from '../../../../json/splashverse-onboarding/floating-subject.json';
import JsonDataMobile from '../../../../json/splashverse-onboarding/floating-subject-mobile.json';
import MathJsonData from '../../../../json/splashverse-onboarding/math-subject-selection.json';
import MathJsonDataMobile from '../../../../json/splashverse-onboarding/math-subject-selection-mobile.json';
import ElaJsonData from '../../../../json/splashverse-onboarding/ela-subject-selection.json';
import ElaJsonDataMobile from '../../../../json/splashverse-onboarding/ela-subject-selection-mobile.json';
import * as S from './style';
import { setBackButtonLoading } from '../../../stores/splashverse-onboarding/actions';
import { useDispatch } from 'react-redux'
import { breakpoints } from '../../../utils/responsive_utilities';

const FloatingSubjects = ({
  subjectSelectedHandler, 
  setHeader, 
  doHeaderTransition, 
  }) => {
  let animationContainer = null;
  const isMobilePortrait = useMediaQuery({ maxWidth: breakpoints.sm, orientation: 'portrait' });
  const animationContainerElement = isMobilePortrait ? "animation-container-mobile" : "animation-container";

  useEffect(() => {
    const animationData = isMobilePortrait ? JsonDataMobile : JsonData
    startAnimation(animationData, true);
  },[])

  const dispatch = useDispatch();

  const startAnimation = (animationData, loop, onSuccessHandler) => {
    Lottie.destroy('subject');
    animationContainer = Lottie.loadAnimation({
      container: document.getElementById(animationContainerElement),
      animationData: animationData,
      loop: loop,
      renderer: 'svg',
      name: 'subject',
      rendererSettings: {
        className: 'hola',
        preserveAspectRatio: 'xMidYMid slice',
      }
    })
    if (onSuccessHandler) {
      animationContainer && animationContainer.addEventListener('complete', onSuccessHandler);
    }
  }

  const clickMethod = (subject) => {
    trackAnalyticsEvent('Subject Selected', {'Via': 'Onboarding', 'Subject Selected': subject});
    const mathAnimationData = isMobilePortrait ? MathJsonDataMobile : MathJsonData;
    const elaAnimationData = isMobilePortrait ? ElaJsonDataMobile : ElaJsonData;

    let SubjectJson = {
      math: mathAnimationData,
      ela: elaAnimationData
    }
    doHeaderTransition();
    setHeader({
      math: 'Math',
      ela: 'Reading'
    }[subject]);
    sessionStorage.setItem('coq_answers', subject);
    dispatch(setBackButtonLoading());
    startAnimation(SubjectJson[subject], false, () => subjectSelectedHandler(subject)); 
  }

  return (
    <>
      <S.Subjects id={animationContainerElement}>
        <S.HiddenClickContainer onClick={()=>clickMethod('math')}></S.HiddenClickContainer>
        <S.HiddenClickContainer onClick={()=>clickMethod('ela')}></S.HiddenClickContainer>
      </S.Subjects>
    </>
  )
}

export default FloatingSubjects;